<template>
  <div class="banner-wrapper" v-show="bannerList.length">
    <van-swipe :autoplay="5000" @change="onBannerChange" ref="swipe">
      <van-swipe-item v-for="(image, index) in bannerList" :key="index">
        <img
          @dragstart.prevent
          @dragstart="onDragstart"
          @click="jumpPage(image)"
          v-lazy="image.picture"
          :alt="`${gameName} banner`"
          :class="['game-background-cover', gameName]"
        />
      </van-swipe-item>
    </van-swipe>
    <Banner ref="desktopBanner" @login="login" />
  </div>
</template>
<script>
  import Banner from '@/components/Banner'
  import { mapState } from 'vuex'
  import { getLoginStatus } from '@/utils/login'
  import { pageBannerShow } from '@/pages/firebase'
  import { fetchDetailConfig } from '@/api/games'
  import '@vant/touch-emulator'

  let timer = null
  export default {
    components: { Banner },
    props: {},
    data() {
      return {
        bannerList: [],
        exposedId: [],
        dragstart: false, // 是否开始拖动
        initLoad: true,
      }
    },
    computed: {
      ...mapState(['gameName', 'isGetapps', 'region', 'source', 'userInfo']),
    },
    watch: {
      userInfo: {
        handler() {
          this.getBannerDatas()
        },
        deep: true,
        immediate: true,
      },
      bannerList: {
        handler(newvalue) {
          // https://vant-ui.github.io/vant/v2/#/zh-CN/swipe
          if (newvalue && newvalue.length) {
            timer = setTimeout(() => {
              this.$refs.swipe && this.$refs.swipe.resize()
            }, 500)
          }
        },
        deep: true,
      },
    },
    created() {},
    beforeDestroy() {
      clearTimeout(timer)
    },
    methods: {
      onDragstart() {
        this.dragstart = true
      },
      jumpPage(item) {
        // 通过dragstart判断是否开始拖动，如果拖动过程中触发了点击事件，不继续执行
        if (this.dragstart) {
          this.dragstart = false
          return
        }
        if (this.isGetapps) {
          return
        }
        this.$refs.desktopBanner && this.$refs.desktopBanner.jumpPage(item)
      },
      login(type) {
        if (getLoginStatus()) return
        this.$emit('login', type)
      },
      trackBannerShow(item) {
        if (!this.exposedId.includes(item.id)) {
          pageBannerShow({
            list_id: item.id || 0,
            page: this.gameName,
          })
          this.exposedId.push(item.id)
        }
      },
      onBannerChange(index) {
        const item = this.bannerList[index]
        this.trackBannerShow(item)
      },
      async getBannerDatas() {
        const {
          bannerConfig: { detailPageBanners = [] },
        } = await fetchDetailConfig(
          {
            country: this.region,
            game: this.gameName,
            source: this.source,
          },
          {
            cacheFlag: false,
          }
        )
        const isLen = detailPageBanners.length === 0
        this.bannerList = detailPageBanners
        this.$emit('handerBannerList', isLen)
      },
    },
  }
</script>
<style lang="scss" scoped>
  @media screen and (min-device-width: 1080px) {
    @import './desktop_new_pc.scss';
  }

  @media (max-width: 900px) {
    @import './900.scss';
  }
</style>
